import axios, { AxiosResponse } from 'axios'

import gql from '../../utils/gql'
import getStoreName from '../../utils/getStoreName'
import getBearerToken from '../../utils/getBearerToken'

interface SetSubscriptionStatusInterface {
  data: {
    changeSubscriptionStatus: {
      entity_id: number
      status: string
    }
  }
}

//setting subscription status
export const SubscriptionStatusMutation = gql`
  mutation ChangeSubscriptionStatus($entity_id: Int!, $status: String!) {
    changeSubscriptionStatus(entity_id: $entity_id, status: $status) {
      entity_id
      status
    }
  }
`

/**
 * @throws {string} Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 * @param {number} entity_id - The entity ID of the subscription to change the status of.
 * @param {string} status - The new status of the subscription. Can be 'active', 'paused', or 'canceled'.
 * @returns {Promise<setSubscriptionDataStatus>} - The response from the server.
 */

export const setSubscriptionStatus = async (
  entity_id: number,
  status: string
): Promise<string> => {
  const bearerToken = getBearerToken()

  try {
    const { data }: AxiosResponse<SetSubscriptionStatusInterface> = await axios(
      {
        method: 'POST',
        url: process.env.MIX_MAGENTO_GRAPHQL,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearerToken}`,
          Store: getStoreName(),
        },
        data: {
          query: SubscriptionStatusMutation,
          variables: {
            entity_id,
            status,
          },
        },
      }
    )
    if (data?.data?.changeSubscriptionStatus) {
      return data.data.changeSubscriptionStatus.status
    } else {
      console.error('Unexpected response structure:', data)
      return 'error'
    }
  } catch (error) {
    console.error('Error with Status Response:', error)
    return 'error'
  }
}
